const STORAGE_KEY = 'top14_affiliate_source';
const STORAGE_TS_KEY = 'top14_affiliate_source_at';
/** Koliko dugo pamtimo affiliate izvor posle prvog klika (30 dana). */
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export function normalizeAffiliateSource(v: unknown): string {
  if (typeof v !== 'string') return '';
  const normalized = v.trim().slice(0, 80);
  if (!normalized) return '';
  return normalized.replace(/[^a-zA-Z0-9_-]/g, '');
}

function readStoredAffiliateSource(): string {
  if (typeof window === 'undefined') return '';
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    const tsRaw = localStorage.getItem(STORAGE_TS_KEY);
    if (!value || !tsRaw) return '';
    const ts = Number(tsRaw);
    if (!Number.isFinite(ts) || Date.now() - ts > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_TS_KEY);
      return '';
    }
    return normalizeAffiliateSource(value);
  } catch {
    return '';
  }
}

function writeStoredAffiliateSource(source: string): void {
  if (typeof window === 'undefined' || !source) return;
  try {
    localStorage.setItem(STORAGE_KEY, source);
    localStorage.setItem(STORAGE_TS_KEY, String(Date.now()));
  } catch {
    // Private mode / blocked storage — ignore.
  }
}

/** Čita `aff` ili `affiliate` iz query stringa i upisuje u storage ako postoji. */
export function captureAffiliateSourceFromSearch(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const fromUrl = normalizeAffiliateSource(params.get('aff') ?? params.get('affiliate'));
  if (fromUrl) {
    writeStoredAffiliateSource(fromUrl);
    return fromUrl;
  }
  return readStoredAffiliateSource();
}

export function getStoredAffiliateSource(): string {
  return readStoredAffiliateSource();
}

/** `?aff=capitaale` za trenutno sačuvan izvor, ili prazan string. */
export function affiliateQueryString(): string {
  const aff = getStoredAffiliateSource();
  return aff ? `?aff=${encodeURIComponent(aff)}` : '';
}

/** Dodaje sačuvani `aff` na putanju (npr. pri promeni jezika). */
export function pathWithAffiliateQuery(pathname: string, hash = ''): string {
  const aff = getStoredAffiliateSource();
  if (!aff) return `${pathname}${hash}`;
  const url = new URL(pathname, 'https://top14.rs');
  url.searchParams.set('aff', aff);
  return `${url.pathname}${url.search}${hash}`;
}
